function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M24.125 16c0 0.345-0.28 0.625-0.625 0.625s-0.625-0.28-0.625-0.625c0-0.345 0.28-0.625 0.625-0.625s0.625 0.28 0.625 0.625z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M17.875 12.25c0 0.345-0.28 0.625-0.625 0.625s-0.625-0.28-0.625-0.625c0-0.345 0.28-0.625 0.625-0.625s0.625 0.28 0.625 0.625z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M16.625 25.375c0 0.345-0.28 0.625-0.625 0.625s-0.625-0.28-0.625-0.625c0-0.345 0.28-0.625 0.625-0.625s0.625 0.28 0.625 0.625z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M7.25 14.125c0 0.345-0.28 0.625-0.625 0.625s-0.625-0.28-0.625-0.625c0-0.345 0.28-0.625 0.625-0.625s0.625 0.28 0.625 0.625z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M9.125 24.75c1.378 0 2.5-1.122 2.5-2.5s-1.122-2.5-2.5-2.5c-1.378 0-2.5 1.122-2.5 2.5s1.122 2.5 2.5 2.5zM9.125 21c0.689 0 1.25 0.561 1.25 1.25s-0.561 1.25-1.25 1.25c-0.689 0-1.25-0.561-1.25-1.25s0.561-1.25 1.25-1.25z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M14.75 7.875c0-1.378-1.122-2.5-2.5-2.5s-2.5 1.122-2.5 2.5c0 1.378 1.122 2.5 2.5 2.5s2.5-1.122 2.5-2.5zM11 7.875c0-0.689 0.561-1.25 1.25-1.25s1.25 0.561 1.25 1.25c0 0.689-0.561 1.25-1.25 1.25s-1.25-0.561-1.25-1.25z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M19.125 21.625c0 1.378 1.122 2.5 2.5 2.5s2.5-1.122 2.5-2.5c0-1.378-1.122-2.5-2.5-2.5s-2.5 1.122-2.5 2.5zM22.875 21.625c0 0.689-0.561 1.25-1.25 1.25s-1.25-0.561-1.25-1.25c0-0.689 0.561-1.25 1.25-1.25s1.25 0.561 1.25 1.25z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M14.75 19.125c1.034 0 1.875-0.841 1.875-1.875s-0.841-1.875-1.875-1.875c-1.034 0-1.875 0.841-1.875 1.875s0.841 1.875 1.875 1.875zM14.75 16.625c0.345 0 0.625 0.28 0.625 0.625s-0.28 0.625-0.625 0.625c-0.345 0-0.625-0.28-0.625-0.625s0.28-0.625 0.625-0.625z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M16.625 31.375c0 0.345-0.28 0.625-0.625 0.625s-0.625-0.28-0.625-0.625c0-0.345 0.28-0.625 0.625-0.625s0.625 0.28 0.625 0.625z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M30.9 13.152c-0.406 0.205-1.059 0.348-1.587 0.348-1.242 0-2.466-0.718-2.976-1.745-0.135-0.272-0.447-0.408-0.739-0.321-0.437 0.131-0.806 0.191-1.16 0.191-2.24 0-4.063-1.822-4.063-4.063 0-0.354 0.061-0.723 0.191-1.16 0.087-0.292-0.048-0.604-0.321-0.739-1.028-0.51-1.745-1.734-1.745-2.976 0-0.529 0.143-1.182 0.348-1.587 0.090-0.179 0.090-0.39-0.002-0.568s-0.263-0.301-0.461-0.332c-0.89-0.137-1.648-0.2-2.386-0.2-8.624 0-16 7.363-16 16 0 7.501 5.624 14.258 13.081 15.717 0.339 0.066 0.667-0.155 0.733-0.494s-0.155-0.667-0.493-0.733c-6.881-1.346-12.071-7.575-12.071-14.49 0-7.995 6.755-14.75 14.75-14.75 0.456 0 0.924 0.027 1.436 0.084-0.118 0.438-0.186 0.917-0.186 1.353 0 1.517 0.8 3.022 1.994 3.834-0.081 0.365-0.119 0.704-0.119 1.041 0 2.929 2.383 5.313 5.313 5.313 0.337 0 0.676-0.038 1.041-0.119 0.812 1.194 2.317 1.994 3.834 1.994 0.436 0 0.915-0.068 1.353-0.186 0.057 0.512 0.084 0.98 0.084 1.436 0 6.915-5.189 13.144-12.071 14.49-0.339 0.066-0.559 0.395-0.493 0.733s0.395 0.56 0.733 0.494c7.457-1.459 13.081-8.215 13.081-15.717 0-0.738-0.064-1.495-0.2-2.386-0.064-0.419-0.52-0.655-0.9-0.463z"
});

function SvgCookies(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "cookies") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCookies);
export default __webpack_public_path__ + "static/media/cookies.dcbe64b0.svg";
export { ForwardRef as ReactComponent };